export default m => (m < 10 ? "0" + m : m);